import React, { useEffect } from 'react';

interface GoogleAdProps {
  slot: string;
  style?: React.CSSProperties;
  format?: string;
  layout?: string;
}

const GoogleAd: React.FC<GoogleAdProps> = ({ 
  slot, 
  style = {}, 
  format = "auto",
  layout = "in-article"
}) => {
  useEffect(() => {
    try {
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.warn("Adsense error:", e);
    }
  }, []);

  const defaultStyle: React.CSSProperties = {
    display: 'block',
    textAlign: 'center',
    minHeight: format === 'fluid' ? '100px' : '280px',
    width: '100%',
    overflow: 'hidden',
    backgroundColor: 'transparent',
    ...style,
  };

  return (
    <div 
      style={defaultStyle} 
      className="google-ad"
    >
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-6338038731129939" 
        data-ad-slot={slot}
        data-ad-format={format}
        data-ad-layout={layout}
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default GoogleAd;